import React from "react";
import PropTypes from "prop-types";
import AfricaMap from "../map";
import FinancingCharts from "./FinancingCharts";
import CountryODAChart from "./CountryODACharts";

const Highcharts = window.Highcharts;

const ODAIndex = ({ mapOptions, selectedCountry, data, overallOdaData }) => (
  <div>
    <section className="oda">
      <div className="map-wrapper">
        <div className="map-help">
        {
          selectedCountry === "all" &&
          <div>
            Click on a country to see financing
            <div className="border" />
          </div>
        }
        </div>
        <AfricaMap options={mapOptions} highcharts={Highcharts} selectedCountry={selectedCountry} />
      </div>
      <div className="chart-wrapper">
        {selectedCountry !== "all" ?
          <CountryODAChart data={data} />
          :
          <FinancingCharts overallOdaData={overallOdaData} />
        }
      </div>
    </section>
  </div>
);

export default ODAIndex;

ODAIndex.propTypes = {
  data: PropTypes.shape({}).isRequired,
  mapOptions: PropTypes.shape({}).isRequired,
  overallOdaData: PropTypes.shape({}).isRequired,
  selectedCountry: PropTypes.string.isRequired,
};
